// Contract of GET/PUT v1/integrations/zigi and the ZIGI admin endpoints.
export const ZIGI_SLUG = 'zigi';

// Secret settings never come back in clear: when stored they return as this mask.
export const ZIGI_MASKED_VALUE = '***';

export const ZIGI_PLAIN_KEYS = ['apiUrl', 'businessCode', 'currency', 'expiryTimeMinutes', 'redirectUrl'] as const;
export const ZIGI_SECRET_KEYS = ['apiKey', 'webhookKey'] as const;

export type ZigiPlainKey = (typeof ZIGI_PLAIN_KEYS)[number];
export type ZigiSecretKey = (typeof ZIGI_SECRET_KEYS)[number];
export type ZigiKey = ZigiPlainKey | ZigiSecretKey;

// Deep link the app registers so ZIGI can bring the customer back after paying.
export const ZIGI_APP_RETURN_URL = 'com.mcdonalds://zigi-return';

// Without these the backend cannot create charges, so the integration must stay disabled.
export const ZIGI_REQUIRED_TO_ENABLE: ReadonlyArray<ZigiKey> = ['apiUrl', 'apiKey', 'businessCode'];

export const ZIGI_BUSINESS_CODE_MAX_LENGTH = 15;
export const ZIGI_CURRENCY_LENGTH = 3;
// Suggested charge link expiry; unpaid ZIGI orders are cancelled after the configured value.
export const ZIGI_MAX_RECOMMENDED_EXPIRY_MINUTES = 10;
// LEGACY_SETTINGS_INVALID in the backend: raised when the webhook is registered without a saved webhookKey.
export const ZIGI_WEBHOOK_KEY_MISSING_CODE = 18410;
// ZIGI error when the merchant already has a webhook; there is no endpoint to replace it.
export const ZIGI_WEBHOOK_DUPLICATE_CODE = 20155;
export const ZIGI_WEBHOOK_URL_MAX_LENGTH = 200;
export const ZIGI_WEBHOOK_PATH = 'v1/webhooks/zigi/payment-notification';

export type ZigiStoredValue = string | number | { $secretRef: string } | null;

export interface ZigiIntegrationResponse {
  slug: string;
  name: string;
  type: string;
  country: string | null;
  enabled: boolean;
  settings: Partial<Record<ZigiKey, ZigiStoredValue>>;
  updatedAt: string;
}

export interface ZigiBusiness {
  businessName: string;
  businessCode: string;
  businessId: string;
}

export interface ZigiBusinessesResponse {
  results: ZigiBusiness[];
}

// The backend registers the webhook with the stored webhookKey, so only the URL travels.
export interface ZigiRegisterWebhookBody {
  url: string;
}

export interface ZigiRegisterWebhookResponse {
  message: string;
}

export type ZigiAdminErrorCode = 'ZIGI_API_REQUEST_FAILED' | 'ZIGI_NOT_CONFIGURED' | 'ZIGI_UNKNOWN_ERROR';

export interface ZigiAdminError {
  message: string;
  code: ZigiAdminErrorCode | number;
  zigiCode?: string | number;
  requestId?: string;
}
